import { PlusOutlined } from '@ant-design/icons'
import { Button, Modal, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DeliverySubscriptionType } from '../../../../../types/deliverySubscription/DeliverySubscription'
import { useDeliverySubscriptionSave } from '../../../../../features/deliverySubscriptions/hooks/useDeliverySubscriptionSave'
import { useSubscriptionFormState } from '../../../../../features/deliverySubscriptions/hooks/useSubscriptionFormState'
import CompanyDashboardSubscriptionForm from '../../../../../features/deliverySubscriptions/forms/CompanyDashboardSubscriptionForm'
import { DeliverySubscriptionFormData } from '../../../../../features/deliverySubscriptions/types'
import DeliverySubscriptionTable from './components/DeliverySubscriptionTable'

const CompanyDashboardSubscriptions: React.FC = () => {
  const { t } = useTranslation()
  const [form] = useForm<DeliverySubscriptionFormData>()
  const { open, deliverySubscription, handleClose, openForEdit, openForCreate } = useSubscriptionFormState(form)

  const { handleSave, isSaving } = useDeliverySubscriptionSave({
    subscriptionType: DeliverySubscriptionType.COMPANY_DASHBOARD,
    deliverySubscription,
    form,
    onSuccess: handleClose
  })

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
        <Button type="primary" onClick={openForCreate}>
          <PlusOutlined />
          {t('global:add-new')}
        </Button>
      </div>
      <Modal
        destroyOnHidden
        title={
          deliverySubscription ? t('subscriptionsPage:edit-subscription') : t('subscriptionsPage:add-subscription')
        }
        open={open}
        maskClosable={false}
        onCancel={handleClose}
        footer={
          <Space>
            <Button onClick={handleClose}>{t('global:cancel')}</Button>
            <Button type="primary" loading={isSaving} onClick={handleSave}>
              {deliverySubscription ? t('global:update') : t('global:save')}
            </Button>
          </Space>
        }
      >
        <CompanyDashboardSubscriptionForm form={form} deliverySubscription={deliverySubscription} />
      </Modal>
      <DeliverySubscriptionTable
        subscriptionType={DeliverySubscriptionType.COMPANY_DASHBOARD}
        toggleDeliverySubscription={openForEdit}
      />
    </>
  )
}

export default CompanyDashboardSubscriptions
